<template>
  <div class="panel-group" :id="id" role="tablist" aria-multiselectable="true">
    <slot></slot>
  </div>
</template>
<script>
  export default {

    name: 'BaseAccordionList',

    props: {
      id: {
        type: String,
      },
    },
  };
</script>
